import { defineStore } from 'pinia'

export const useBrochureRequest = defineStore('brochureRequest', {
  state: () => ({
    firstName: '',
    email: '',
    zipCode: '',
    childAges: [],
    interests: [],
    isUser: false,
    isOptedOutEmail: false,
    isOptedOutSMS: false,
    // Add a flag to trigger the lead gen modal
    leadGenModalTrigger: false,
  }),

  persist: {
    storage: persistedState.localStorage,
  },

  actions: {
    update(user) {
      if (user.firstName) {
        this.firstName = user.firstName.value || user.firstName;
      }
      if (user.emailAddress) {
      this.email = user.emailAddress.value || user.emailAddress;
      }
      if (user.postalCode) {
        this.zipCode = user.postalCode.value || user.postalCode;
      }
      if (user.studentBirthYears && user.studentBirthYears.value) {
        if (user.studentBirthYears.value && user.studentBirthYears.value.length > 0) {
          this.childAges = []
          const currentYear = new Date().getFullYear()
          user.studentBirthYears.value.forEach((e) => {
            this.childAges.push(currentYear - e)
          })
        }
      }
      if (user.learningStyleTypeIDs) {
        this.interests = user.learningStyleTypeIDs.value || user.learningStyleTypeIDs;
      }
    },
    // Action to update the user existence flag
    setIsUser(exists) {
      this.isUser = exists;
    },
    // Action to update the email opt-out flag
    setIsOptedOutEmail(optedOut) {
      this.isOptedOutEmail = optedOut;
    },
    // Action to update the SMS opt-out flag
    setIsOptedOutSMS(optedOut) {
      this.isOptedOutSMS = optedOut;
    },
    // Action to set the lead gen modal trigger
    setLeadGenModalTrigger(val) {
      this.leadGenModalTrigger = val;
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useBrochureRequest, import.meta.hot))
}
